<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h4 class="card-title mb-0">
                        <button class="btn btn-sm btn-outline-secondary me-2" (click)="goBack()">
                            <i class="fa fa-arrow-left"></i>
                        </button>
                        <span class="lstick"></span>Order Details: {{ orderDetails.orderNumber || orderDetails._id }}
                    </h4>

                </div>

                <div *ngIf="loading" class="text-center p-5">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

                <div *ngIf="!loading && orderDetails._id">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="info-group mb-4">
                                <h5 class="text-muted small text-uppercase font-bold">Order Information</h5>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Order Number:</span>
                                    <span>{{ orderDetails.orderNumber }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Status:</span>
                                    <span class="badge" [ngClass]="getStatusBadgeClass(orderDetails.status)">
                                        {{ getStatusLabel(orderDetails.status) }}
                                    </span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Total Amount:</span>
                                    <span class="text-danger font-bold">
                                        {{ orderDetails.currency }} {{ orderDetails.totalAmountWithVat | number: "1.2-2"
                                        }}
                                    </span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Store:</span>
                                    <span>{{ orderDetails.operatorStoreId?.storeName || 'N/A' }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Desk:</span>
                                    <span>{{ orderDetails.deskId?.deskName || 'N/A' }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Payment Type:</span>
                                    <span>{{ orderDetails.paymentType | titlecase }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Date:</span>
                                    <span>{{ orderDetails.created_at | date: "medium" }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-group mb-4">
                                <h5 class="text-muted small text-uppercase font-bold">Customer Information</h5>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Name:</span>
                                    <span>{{ orderDetails.userName }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-bottom py-2">
                                    <span>Mobile:</span>
                                    <span>{{ orderDetails.userDiallingCode }} {{ orderDetails.userMobileNumber }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <h5 class="text-muted small text-uppercase font-bold">Products</h5>
                        <div class="table-responsive">
                            <table class="table table-bordered align-middle">
                                <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Product Name</th>
                                        <th>EAN</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                        <th>VAT %</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of orderDetails.productsItems">
                                        <td>
                                            <img [src]="item.productId?.productImage" alt="Product" width="50"
                                                height="50" class="rounded shadow-sm"
                                                *ngIf="item.productId?.productImage">
                                        </td>
                                        <td>{{ item.productId?.name }}</td>
                                        <td>{{ item.productId?.EANNumber || 'N/A' }}</td>
                                        <td>{{ item.quantity }}</td>
                                        <td>{{ orderDetails.currency }} {{ item.productId?.price | number: "1.2-2" }}
                                        </td>
                                        <td>{{ item.totalVatPercentage }}%</td>
                                        <td>{{ orderDetails.currency }} {{ item.chargeableAmount | number: "1.2-2" }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="mt-4 border-top pt-4 " *ngIf="getAvailableActions().length > 0 || orderDetails._id">
                        <div class="d-flex justify-content-end gap-23">
                            <button class="btn btn-secondary" (click)="PrintDetails(orderDetails)">
                                <i class="fa fa-print me-1"></i> Print Details
                            </button>
                            <button *ngIf="getAvailableActions().includes('accept')" class="btn btn-success"
                                (click)="openModal('accept')">
                                <i class="fa fa-check me-1"></i> Accept Order
                            </button>
                            <button *ngIf="getAvailableActions().includes('readyForPickup')"
                                class="btn btn-info text-white" (click)="openModal('readyForPickup')">
                                <i class="fa fa-truck me-1"></i> Ready to Pickup
                            </button>
                            <button *ngIf="getAvailableActions().includes('complete')" class="btn btn-primary"
                                (click)="openModal('complete')">
                                <i class="fa fa-check-circle me-1"></i> Complete Order
                            </button>
                            <button *ngIf="getAvailableActions().includes('cancel')" class="btn btn-danger"
                                (click)="openModal('cancel')">
                                <i class="fa fa-times me-1"></i> Cancel Order
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>